var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAssets20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006885;}.cls-2{fill:#6cb706;}.cls-2,.cls-3{stroke:#006885;stroke-width:7.11px;}.cls-3{fill:#90d12a;}.cls-4,.cls-5{fill:none;}.cls-5{stroke:#fff;stroke-width:5.33px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12-2",
    "data-name": "Ellipse 12-2",
    className: "cls-1",
    cx: 180,
    cy: 184.2,
    r: 164.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-2",
    d: "M227.2,84.4,108.9,140.8l142.2,72.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-3",
    x: 107.3,
    y: 187.7,
    width: 100.1,
    height: 67.84,
    transform: "translate(-111.5 261.1) rotate(-63)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.9,
    cy: 185.1,
    r: 151.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 180.9,
    cy: 185.1,
    r: 148.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAssets20);
export default __webpack_public_path__ + "static/media/Vector Assets-20.56e7619b9d773f277ba415cabca4c7f2.svg";
export { ForwardRef as ReactComponent };